import { SiNoEnum } from "../enum/si-no-enum";
import { ValoriDefaultDocumentoDTO } from "./valori-default-documentoDTO";
import { CampoSpecificoFascicolazioneDTO } from "./campo-specifico-fascicolazioneDTO";
import { CampoSpecificoConservazioneDTO } from "./campo-specifico-conservazioneDTO";
import { VersioneFuturaDTO } from "./versione-futuraDTO";

export class TipologiaDocumentoDTO {
  id: string;

  nome: string;

  codice: string;

  descrizione: string;

  anniConservazioneDaChiusura: number;

  perSempre: boolean;

  ereditaDaFascicolo: boolean;

  motivazione: string;

  dataManuale: SiNoEnum;

  dataAttivazione: string;

  dataModifica: string;

  dataCessazione: string;

  valoriDefaultDocumento: ValoriDefaultDocumentoDTO;

  campiSpecificiFascicolo: CampoSpecificoFascicolazioneDTO[];

  campiSpecificiConservazione: CampoSpecificoConservazioneDTO[];

  versioneFutura: VersioneFuturaDTO;
}
